<div class="edit-game-modal">
  <div class="edit-game-header">
    <h4>Edit Game Detail</h4>
    <button type="button" class="edit-game-close" aria-label="Close" (click)="closemodel()">
      <img src="assets/icons/icon-close.svg" alt="" />
    </button>
  </div>

  <form [formGroup]="Editgamedetailform">
    <div class="form-group">
      <label for="edit-game-name">Game Name</label>
      <input id="edit-game-name" type="text" formControlName="Gamename">
    </div>

    <div class="form-group">
      <label for="edit-game-time">New Game Time</label>
      <input id="edit-game-time" type="datetime-local" formControlName="Nextgame">
    </div>

    <button type="submit" class="btn btn-theme edit-game-submit" (click)="submit(); Editgamedetailform.markAllAsTouched()">Submit</button>
  </form>
</div>
